import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { EmailComponent } from '@layout/profile-menu/components/email/email.component';
import { AvatarComponent, TooltipDirective } from '@kaseya-design-components';
import { UserInfoFacade } from '@core/user-info/facades/user-info.facade';

@Component({
  selector: 'itc-profile-info',
  templateUrl: 'profile-info.component.html',
  styleUrl: 'profile-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [EmailComponent, TooltipDirective, AvatarComponent],
})
export class ProfileInfoComponent {
  private readonly userInfoFacade = inject(UserInfoFacade);

  readonly email = this.userInfoFacade.userEmail;
  readonly userFirstName = this.userInfoFacade.userFirstName;
  readonly userLastName = this.userInfoFacade.userLastName;
  readonly organizationName = this.userInfoFacade.organizationName;
  readonly userFullName = computed(() => this.userInfoFacade.userFullName() || this.email());

  isTruncated(element: HTMLSpanElement): boolean {
    return element.offsetWidth < element.scrollWidth;
  }
}
